// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordInput_wrapper__5L5Zm","icon":"PasswordInput_icon__k8GXh"};